import usersListComponent from './users-list.component';

const usersListModule = angular
  .module('usersList', [])
  .component('usersList', usersListComponent);

export default usersListModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-list/users-list.js
 **/